import { useEffect, useState } from 'react'
import { useDragScroll } from './useDragScroll'
import { CLUSTERS_CONTAINER_ID } from '../pages/Clusters/Clusters'

export const useClusterLabelDragScroll = (
	elementId: string,
	parentContainerId = CLUSTERS_CONTAINER_ID,
) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 1440)

	// Handle resize to update isMobile
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 1440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	// Call useDragScroll to enable drag on the label
	useDragScroll(elementId, 'horizontal')

	// Logic to block/unblock the parent container
	useEffect(() => {
		// Only on mobile where drag is active
		if (!isMobile) return

		const labelElement = document.getElementById(elementId)
		const parentContainer = document.getElementById(parentContainerId)

		// Failsafe: if elements don't exist, do nothing
		if (!labelElement || !parentContainer) return

		// Handler to block parent scroll
		const blockParentScroll = () => {
			parentContainer.style.overflow = 'hidden'
			parentContainer.style.touchAction = 'none'
		}

		// Handler to unblock parent scroll
		const unblockParentScroll = () => {
			parentContainer.style.overflow = ''
			parentContainer.style.touchAction = ''
		}

		// Register listeners
		labelElement.addEventListener('pointerdown', blockParentScroll)
		window.addEventListener('pointerup', unblockParentScroll)
		window.addEventListener('pointercancel', unblockParentScroll)

		// Cleanup: remove listeners and restore styles
		return () => {
			labelElement.removeEventListener('pointerdown', blockParentScroll)
			window.removeEventListener('pointerup', unblockParentScroll)
			window.removeEventListener('pointercancel', unblockParentScroll)

			// Aggressive cleanup: restore even if elements are gone
			if (parentContainer) {
				parentContainer.style.overflow = ''
				parentContainer.style.touchAction = ''
			}
		}
	}, [elementId, parentContainerId, isMobile])
}
